import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

const BarChart = ({ chartData, chartOptions, height, width }) => {
  if (!chartData?.datasets?.[0]?.data?.length) {
    return null;
  }

  return (
    <div style={{ position: 'relative', height: height ?? 300, width: width ?? '100%' }}>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          ...chartOptions,
        }}
      />
    </div>
  );
};

export default BarChart;
